__turbopack_context__.v({
  "blog": "SiteHeader-module__mdpVJq__blog",
  "blogAttivo": "SiteHeader-module__mdpVJq__blogAttivo",
  "header": "SiteHeader-module__mdpVJq__header",
  "interno": "SiteHeader-module__mdpVJq__interno",
  "logo": "SiteHeader-module__mdpVJq__logo",
  "navigazione": "SiteHeader-module__mdpVJq__navigazione",
  "voce": "SiteHeader-module__mdpVJq__voce",
  "voceAttiva": "SiteHeader-module__mdpVJq__voceAttiva",
});
